export default __webpack_public_path__ + "static/media/person-3.af478f2e.svg";